/* Catálogo REAL de pure-bamboo.es (exportado en solo lectura el 25/10/2026, src/data/products.raw.json).
   Precios y packs = los que hay hoy en la tienda. Nada de esto cambia la tienda publicada. */
window.PB_CATALOG = {
  envioGratis: 50, envio: 4.99,
  products: {
    'bamboo-towel': {
      title: 'Toalla de baño', full: 'Toalla de Baño Premium 100 % Bambú', size: '100 × 140 cm', short: 'Baño',
      line: 'La de todos los días: 100 × 140 cm, más ancha que la estándar, absorbe más de 4 veces su peso.',
      img: ['neus-toallero', 'neus-espalda', 'set-regalo'], video: 'lujo-ducha',
      packs: [ { n: 1, price: 54.99 }, { n: 2, price: 89.99, tag: 'La más elegida' }, { n: 3, price: 119.99, tag: 'Más ahorro' } ],
      gift: 'tote', stock: 429
    },
    'toalla-mano': {
      title: 'Toalla de manos y cabello', full: 'Toalla de Manos/Cabello Premium 100 % Bambú', size: '50 × 100 cm', short: 'Manos y cabello',
      line: 'Para las manos y para el pelo: lo seca sin frotar y sin encresparlo.',
      img: ['manos-producto', 'manos-modelo', 'set-regalo'], video: 'lujo-ganador',
      packs: [ { n: 1, price: 39.99 }, { n: 2, price: 59.99 }, { n: 3, price: 79.99, tag: 'La más elegida' } ],
      gift: 'tote', stock: 81
    },
    'toalla-cara': {
      title: 'Toalla facial', full: 'Toalla Facial 100 % Bambú', size: '30 × 50 cm', short: 'Facial',
      line: 'El último paso de tu rutina: suave, hipoalergénica y sin químicos.',
      img: ['facial-modelo', 'facial-producto', 'set-regalo'], video: 'lujo-cara',
      packs: [ { n: 1, price: 34.99 }, { n: 2, price: 44.99, tag: 'La 2.ª por 10 €' }, { n: 3, price: 59.99, tag: 'Más ahorro' } ],
      gift: 'neceser', stock: 237
    },
    'pure-bamboo-signature-set-facial-manos-bano': {
      title: 'Signature Set', full: 'Pure Bamboo Signature Set (Facial, Manos/Cabello & Baño)', size: 'Baño 100 × 140 · Manos 50 × 100 · Facial 30 × 50 cm', short: 'Set completo',
      line: 'Las tres toallas de tu baño en fibra de bambú: baño, manos y facial.',
      img: ['set-tres', 'set-regalo', 'facial-modelo', 'manos-modelo', 'neus-espalda'], video: 'lujo-regalo',
      separado: 129.97,
      packs: [ { n: 1, price: 99.99, tag: 'Ahorras 29,98 €' }, { n: 2, price: 159.99, tag: 'El más elegido' }, { n: 3, price: 219.99, tag: 'Más ahorro' } ],
      gift: 'tote+neceser', stock: 81
    }
  },
  gifts: { tote: 57818399015295, neceser: 57818401112447 }
};

/* Precios, variantes y stock reales (los pone el tema con Liquid en window.PB_LIVE) */
(function () { const L = window.PB_LIVE || {}, P = window.PB_CATALOG.products;
  Object.keys(P).forEach(h => { const l = L[h]; if (!l) return; P[h].variant = l.v; P[h].available = l.a;
    P[h].packs.forEach(k => { const v = l['p' + k.n]; if (v) k.price = v; }); });
  const s = P['pure-bamboo-signature-set-facial-manos-bano'];
  s.separado = Math.round((P['bamboo-towel'].packs[0].price + P['toalla-mano'].packs[0].price + P['toalla-cara'].packs[0].price) * 100) / 100;
})();
